import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react"; import { CircularProgress, Grid, InputAdornment } from '@mui/material';
import { Fragment, useEffect, useMemo, useState } from 'react';

import { RenderInputsRowByType } from '../../../../components/formGroupGenerator/RenderInputRowByType';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { GroupedContainer } from '../GroupedContainer';
import { GET_ALL_MEDIO_ENVIO, adaptMedioEnvioArray } from '../../../../data/graphQL/queries/Contratos/GestionDePresupuestos/getAllMedioEnvioPresupuesto';
import { GET_ALL_FORMATO_PRESUPUESTO, adaptFormatoPresupuestoArray } from '../../../../data/graphQL/queries/Contratos/GestionDePresupuestos/getAllFormatoPresupuesto';
import { obtenerDataImagen } from '../../../../actions/ImagenAction';
import toast from 'react-hot-toast';
import { adaptGestionPresupuestos } from '../../../../adapters/contrato/gestionPresupuestosAdapter';
import { GET_ARCHIVOS_PRESUPUESTOS, adaptArchivos } from '../../../../data/graphQL/queries/Contratos/GestionDePresupuestos/getArchivosPresupuesto';
import { IMPRIMIR_PRESUPUESTO } from '../../../../data/graphQL/mutations/Contratos/GestionPresupuesto/ImprimirPresupuesto';
import { SOLICITAR_JUSTIFICACION } from '../../../../data/graphQL/mutations/Contratos/GestionPresupuesto/SolicitarJustificacion';
import { adaptResultadoPresupuestoArray, GET_ALL_RESULTADO_PRESUPUESTO } from '../../../../data/graphQL/queries/Contratos/GestionDePresupuestos/getAllResultadoPresupuesto';
import { adaptJustificacion, GET_JUSTIFICACION_BY_EVALUACION_ID } from '../../../../data/graphQL/queries/Contratos/GestionDePresupuestos/getDatosContratoByEvaluacion';
import { adaptRequisitoCliente, GET_REQUISITO_CLIENTE } from '../../../../data/graphQL/queries/Contratos/DatosPrincipales/getRequisitoClienteByClienteId';
import { adaptJustificacionMotivoArray, GET_ALL_JUSTIFICACION_MOTIVO } from '../../../../data/graphQL/queries/Contratos/GestionDePresupuestos/getAllJustificacion';
import { adaptEstadoComercialArray, GET_ALL_ESTADO_COMERCIAL } from '../../../../data/graphQL/queries/Contratos/GestionDePresupuestos/getAllEstadoComercial';
import { adaptEstadoMedicoArray, GET_ALL_ESTADO_MEDICO } from '../../../../data/graphQL/queries/Contratos/GestionDePresupuestos/getAllEstadoMedico';
import { GET_PARAMETROS_SOLICITUD_JUSTIFICACION } from '../../../../data/graphQL/queries/Contratos/GestionDePresupuestos/getParametrosJustificacion';
import moment from 'moment';
import { adaptTipoPresupuestoArray, GET_ALL_TIPO_PRESUPUESTO } from '../../../../data/graphQL/queries/Contratos/GestionDePresupuestos/getAllTipoPresupuesto';
import { TemplatePresupuestoIOMA } from './components/TemplatePresupuestoIOMA';
import jsPDF from 'jspdf';
import fileDownload from 'js-file-download';
import { createRoot } from 'react-dom/client';
import { flushSync } from 'react-dom';
import { TemplatePresupuestoCP } from './components/TemplatePresupuestoCP';
import { adaptPlan, GET_PLANES_BUSCADOR } from '../../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getPlanesEvolAsistencial';
import { UPDATE_GESTION_PRESUPUESTO } from '../../../../data/graphQL/mutations/Contratos/GestionPresupuesto/UpdateGestionPresupuesto';
import { DELETE_DOCUMENTO_CONTRATO } from '../../../../data/graphQL/mutations/Contratos/DeleteDocumentoContrato';
import { ADD_DOCUMENTO_CONTRATO } from '../../../../data/graphQL/mutations/Contratos/AddDocumentoContrato';
import { GET_LIQUIDACION_EVALUACION } from '../../../../data/graphQL/queries/Contratos/GestionDePresupuestos/getLiquidacionByEvaluacion';
import { CAN_REJECT_EVALUACION } from '../../../../data/graphQL/queries/Contratos/GestionInicio/canRejectEvaluacion';
import { RESULTADO_PRESUPUESTO_APROBADO } from '../Contrato';

const idTipoPresupuestoCP = 4;
const ESTADO_MEDICO_APROBADO = 2;
const RESULTADO_PRESUPUESTO_RECHAZO = 3;

export const TabGestionPresupuestos = ({
  contratoEditable,
  stepData,
  handleChangeFullFormData,
  setDataSubmissionCallback,
  fullFormData,
  idEvaluacion,
  idDelegacion,
  isClientAuthNumeric,
  isClientAuthDigital,
  origen,
  refetchGestionPresupuestoRef,
  pageLoading,
  setPageLoading
}) => {
  const [gestionPresupuestos, setGestionPresupuestos] = useState(fullFormData.gestionPresupuestos || {});
  const [medioEnvioCombo, setMedioEnvioCombo] = useState([]);
  const [formatoCombo, setFormatoCombo] = useState([]);
  const [resultadoPresupuestoCombo, setResultadoPresupuestoCombo] = useState([]);
  const [tipoPresupuestoCombo, setTipoPresupuestoCombo] = useState([]);
  const [justificacionMotivoCombo, setJustificacionMotivoCombo] = useState([]);
  const [estadoMedicoCombo, setEstadoMedicoCombo] = useState([]);
  const [estadoComercialCombo, setEstadoComercialCombo] = useState([]);
  const [requisitoCliente, setRequisitoCliente] = useState({});
  const [parametrosJustifiacion, setParametrosJustifiacion] = useState({});
  const [imprimirPresupuestoLoading, setImprimirPresupuestoLoading] = useState(false);
  const [puedeAprobar, setPuedeAprobar] = useState(false);
  const [esPlanConComplejidad, setEsPlanConComplejidad] = useState(false);
  const [preIdResultadoPresupuesto, setPreIdResultadoPresupuesto] = useState();
  const [preFechaResultadoPresupuesto, setPreFechaResultadoPresupuesto] = useState();
  const [cambioNumeroSeguimiento, setCambioNumeroSeguimiento] = useState(false);
  const [esPrimeraEjecucionGetJustificacion, setEsPrimeraEjecucionGetJustificacion] = useState(true);
  const [resultadoPresupuestoPrecargadoInicialmente, setResultadoPresupuestoPrecargadoInicialmente] = useState(false);

  const codCliente = useMemo(() => { return fullFormData?.datosPrincipales?.idCliente; }, [fullFormData?.datosPrincipales?.idCliente]);
  const idPlanCuidado = useMemo(() => { return fullFormData?.evaluacionAsistencial?.idModulo; }, [fullFormData?.evaluacionAsistencial?.idModulo]);
  const noCumpleDiasCondicional = useMemo(() => {
    return (!!parametrosJustifiacion?.diasCondiContrato || parametrosJustifiacion?.diasCondiContrato === 0) && (
      !!requisitoCliente?.diasMaxFactCliente || requisitoCliente?.diasMaxFactCliente === 0) &&
      parametrosJustifiacion?.diasCondiContrato >= requisitoCliente?.diasMaxFactCliente / 2;
  },
    [requisitoCliente, parametrosJustifiacion]);
  const apruebaCrediticia = useMemo(() => { return fullFormData?.gestionCrediticia?.idEstadoCrediticio === 1; }, [fullFormData?.gestionCrediticia?.idEstadoCrediticio]);
  const apruebaAsistencial = useMemo(() => { return fullFormData?.evaluacionAsistencial?.estadoMedico === 2; }, [fullFormData?.evaluacionAsistencial?.estadoMedico]);

  const resultadoCondicionalId = useMemo(() => { return resultadoPresupuestoCombo?.find((x) => x.displayName == 'Condicional')?.id; }, [resultadoPresupuestoCombo]);

  const ESTADO_PRECIO_PENDIENTE = 1;
  const ESTADO_PRECIO_APROBADO = 2;
  const ESTADO_CREDITICIA_SATISFACTORIO = 1;

  useEffect(() => { handleChangeFullFormData('gestionPresupuestos', gestionPresupuestos); }, [gestionPresupuestos]);

  const [getCanRejectEvaluacion, { loading: verifyRecjectEvalLoading }] = useLazyQuery(CAN_REJECT_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

  const [getLiquidacionEvaluacion, { loading: verifyLiquidacionEvalLoading }] = useLazyQuery(GET_LIQUIDACION_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

  const handleChange = (name, value) => {
    if (name === 'idResultadoPresupuesto' && (value === RESULTADO_PRESUPUESTO_APROBADO || value === RESULTADO_PRESUPUESTO_RECHAZO)) {
      if (validatePrecioDiario()) return; // Si el precio diario no es válido, no se cambia el resultado del presupuesto) 
      return handleChangeIdResultadoPresupuesto(name, value);
    }

    if (name === 'numeroSeguimiento') {
      if (validatePrecioDiario()) return; // Si el precio diario no es válido, no se cambia el resultado del presupuesto) 

      return handleChangeNumeroSeguimiento(name, value);
    }

    setGestionPresupuestos((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const validatePrecioDiario = () => {
    let textError = [];

    if (fullFormData?.condicionesContrato?.estadoPrecio === ESTADO_PRECIO_PENDIENTE)
      textError.push('Se debe aprobar el precio del contrato antes de cambiar el resultado del presupuesto.\n');
    if (fullFormData?.condicionesContrato?.estadoPrecio !== ESTADO_PRECIO_APROBADO && fullFormData?.condicionesContrato?.precioDiario < fullFormData?.condicionesContrato?.precioControl)
      textError.push('Se debe solicitar autorización de precio porque el precio diario ingresado es menor al precio control.\n');
    if (!fullFormData?.condicionesContrato?.fechaDesde || !fullFormData?.condicionesContrato?.fechaHasta)
      textError.push('El contrato debe tener fecha desde y fecha hasta antes de presentar un presupuesto.\n');

    if (textError.length > 0)
      toast.error(textError.join(' '));

    return textError.length > 0;
  };

  const handleChangeNumeroSeguimiento = (name, value) => {
    setCambioNumeroSeguimiento(true);
    const trimmedValue = value?.trim();

    setGestionPresupuestos((prevDatos) => {
      const updatedGestionPresupuestos = { ...prevDatos, [name]: trimmedValue };

      const shouldApprove = !!trimmedValue && (
        isClientAuthNumeric && !isClientAuthDigital ||
        isClientAuthNumeric && isClientAuthDigital && updatedGestionPresupuestos.presupuestoAutorizado?.titulo);

      if (shouldApprove) {
        updatedGestionPresupuestos.idResultadoPresupuesto = RESULTADO_PRESUPUESTO_APROBADO;
        updatedGestionPresupuestos.fechaResultadoPresupuesto = moment().format('yyyy-MM-DD');
      } else {
        updatedGestionPresupuestos.idResultadoPresupuesto = preIdResultadoPresupuesto;
        updatedGestionPresupuestos.fechaResultadoPresupuesto = preFechaResultadoPresupuesto;
      }

      return updatedGestionPresupuestos;
    });
  };

  const handleChangeIdResultadoPresupuesto = async (name, value) => {
    const rechazadoId = resultadoPresupuestoCombo?.find((x) => x.displayName === 'Rechazado')?.id;
    if (value === rechazadoId) {
      const response = await getCanRejectEvaluacion({
        variables: { idEvaluacion }
      });
      const { data } = response;
      if (!data || data.canRejectEvaluacion?.error) {
        toast.error(data.canRejectEvaluacion?.error ?
          'Usted no puede rechazar el presupuesto del contrato por que existen conexiones, para poder realizarlo se deben quitar las mismas' :
          'Error al verificar si se puede rechazar la evaluación'
        );
        return;
      }

      const responseLiquidacion = await getLiquidacionEvaluacion({
        variables: { idEvaluacion }
      });
      if (responseLiquidacion.data?.hasLiquidacionPendienteEvaluacion?.valorEsperado) {
        toast.error(responseLiquidacion.data.hasLiquidacionPendienteEvaluacion?.valorEsperado ?
          'Usted no puede rechazar el presupuesto del contrato porque existe una liquidación en proceso' :
          responseLiquidacion.data.hasLiquidacionPendienteEvaluacion?.error
        );
        return;
      }
    }

    if (value == null) {
      const envioPreviamentePresupuesto = !!gestionPresupuestos?.fechaEnvioPresupuesto && !!gestionPresupuestos?.idMedioEnvio;
      setGestionPresupuestos((prevForm) => ({
        ...prevForm,
        [name]: value,
        ['fechaResultadoPresupuesto']: null,
        ['fechaEnvioPresupuesto']: envioPreviamentePresupuesto ? prevForm?.fechaEnvioPresupuesto : null
      }));
    } else {
      setGestionPresupuestos((prevForm) => ({
        ...prevForm,
        [name]: value
      }));
    }
  };

  const [getPlanes, { loading: planesLoading }] = useLazyQuery(GET_PLANES_BUSCADOR, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  });

  useEffect(() => {
    const cumpleTipoAutorizacion = isClientAuthDigital && isClientAuthNumeric && !!gestionPresupuestos?.presupuestoAutorizado?.titulo && !!gestionPresupuestos?.numeroSeguimiento ||
      isClientAuthDigital && !isClientAuthNumeric && !!gestionPresupuestos?.presupuestoAutorizado?.titulo ||
      isClientAuthNumeric && !isClientAuthDigital && !!gestionPresupuestos?.numeroSeguimiento ||
      !isClientAuthNumeric && !isClientAuthDigital && !!gestionPresupuestos?.presupuestoAutorizado?.titulo;


    const auxValue = cumpleTipoAutorizacion && apruebaCrediticia && apruebaAsistencial;
    //&& (origen == 'PP' || (origen != 'PP' && esPlanConComplejidad)); //Validamos que sea un plan con complejidad solo para contratos que puedan tener dias condicional

    setPuedeAprobar(auxValue);
  }, [gestionPresupuestos, isClientAuthNumeric, isClientAuthDigital, apruebaCrediticia, apruebaAsistencial, esPlanConComplejidad]);

  useEffect(() => {
    if (!!idPlanCuidado && !planesLoading) {
      getPlanes({
        variables: {
          skip: 0, take: 1,
          where: {
            idPlanCuidado: { eq: idPlanCuidado }
          }
        }
      }).
        then(({ data }) => {
          const plan = adaptPlan(data?.allPlanCuidado.items[0]);
          setEsPlanConComplejidad(Boolean(plan?.complejidadModulo));
        }).
        catch((error) => console.error(error));
    }
  }, [idPlanCuidado]);

  const [getArchivosPresupuesto, { data: dataArchivosPresupuesto }] = useLazyQuery(GET_ARCHIVOS_PRESUPUESTOS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataArchivosPresupuesto) return;
    const adaptedData = adaptArchivos(dataArchivosPresupuesto?.archivosGestionPresupuestos);
    handleChange('idTransferenciaParticulares', adaptedData?.idTransferenciaParticulares);
    handleChange('transferenciaParticulares', !!adaptedData?.transferenciaParticulares ? { ...adaptedData?.transferenciaParticulares } : null);
    handleChange('idPresupuestoAutorizado', adaptedData?.idPresupuestoAutorizado);
    handleChange('presupuestoAutorizado', !!adaptedData?.presupuestoAutorizado ? { ...adaptedData?.presupuestoAutorizado } : null);
  }, [dataArchivosPresupuesto]);


  const [getRequisitoCliente, { data: dataRequisitoCliente }] = useLazyQuery(GET_REQUISITO_CLIENTE, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataRequisitoCliente) return;
    if (dataRequisitoCliente?.requisitoClienteByClienteId !== null) {
      setRequisitoCliente(adaptRequisitoCliente(dataRequisitoCliente?.requisitoClienteByClienteId));
    }
  }, [dataRequisitoCliente]);


  useEffect(() => {
    if (!!codCliente) {
      getRequisitoCliente({ variables: { codCliente: codCliente } });
    }
  }, [codCliente]);

  const { data: dataParametrosSolicitud } = useQuery(GET_PARAMETROS_SOLICITUD_JUSTIFICACION, {
    fetchPolicy: 'no-cache',
    variables: {
      idEvaluacion: idEvaluacion
    }
  });

  useEffect(() => {
    if (!dataParametrosSolicitud) return;
    if (dataParametrosSolicitud?.parametrosSolicitudPresupuesto !== null) {
      setParametrosJustifiacion(dataParametrosSolicitud?.parametrosSolicitudPresupuesto);
    }
  }, [dataParametrosSolicitud]);


  const [getJustificacion, { data: dataJustificacion }] = useLazyQuery(GET_JUSTIFICACION_BY_EVALUACION_ID, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataJustificacion) return;
    if (dataJustificacion?.evaluacionById !== null) {
      const gestionAux = adaptJustificacion(dataJustificacion?.evaluacionById);
      setPreIdResultadoPresupuesto(gestionAux?.idResultadoPresupuesto);
      setPreFechaResultadoPresupuesto(gestionAux?.fechaResultadoPresupuesto);

      if (esPrimeraEjecucionGetJustificacion) {
        setResultadoPresupuestoPrecargadoInicialmente(!!gestionAux?.idResultadoPresupuesto);
        setEsPrimeraEjecucionGetJustificacion(false);
      }

      setGestionPresupuestos((prevDatos) => ({
        ...prevDatos,
        ...gestionAux
      }));
    }
  }, [dataJustificacion]);


  useEffect(() => {
    refetchGestionPresupuestoRef.current = getJustificacion;
  }, [getJustificacion]);

  useEffect(() => {
    if (!!idEvaluacion) {
      getJustificacion({ variables: { idEvaluacion: idEvaluacion } });
      getArchivosPresupuesto({ variables: { idEvaluacion: idEvaluacion } });
    }
  }, [idEvaluacion]);

  const [updateGestionPresupuesto] = useMutation(UPDATE_GESTION_PRESUPUESTO);

  const handleChangeImage = (name, value) => {
    if (name === 'presupuestoAutorizado')
      if (validatePrecioDiario()) return; // Si el precio diario no es válido, no se cambia el resultado del presupuesto) 

    obtenerDataImagen(value).then(async (image) => {
      const fileIsPresupuestoAut = name === 'presupuestoAutorizado';
      const idTipoArchivoSelected = fileIsPresupuestoAut ? 16 : 38;
      const updateFile = {
        contentType: image?.tipo,
        archivo: image?.data,
        extension: image?.extension,
        titulo: image?.nombre
      };
      handleChange(name, updateFile);

      if (fileIsPresupuestoAut && cambioNumeroSeguimiento) {
        await handleSubmit();
      }
      await addDocumento({
        variables: {
          idEvaluacion,
          documentoContratoState: idTipoArchivoSelected,
          documentoInput: updateFile
        }
      });

      getJustificacion({ variables: { idEvaluacion: idEvaluacion } });
      getArchivosPresupuesto({ variables: { idEvaluacion: idEvaluacion } });
    });
  };

  const [imprimirPresupuesto] = useMutation(IMPRIMIR_PRESUPUESTO, {
    fetchPolicy: 'no-cache',
    variables: {
      idEvaluacion,
      idDelegacion,
      idTipoPresupuesto: gestionPresupuestos?.tipoPresupuesto
    },
    refetchQueries: [GET_JUSTIFICACION_BY_EVALUACION_ID]
  });

  const [solicitarJustificacion] = useMutation(SOLICITAR_JUSTIFICACION);

  const [addDocumento] = useMutation(ADD_DOCUMENTO_CONTRATO);

  const { data: dataTipoPresupuesto } = useQuery(GET_ALL_TIPO_PRESUPUESTO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataTipoPresupuesto) return;
    setTipoPresupuestoCombo(adaptTipoPresupuestoArray(dataTipoPresupuesto?.allTipoPresupuesto));
  }, [dataTipoPresupuesto]);

  const { data: dataResultadoPresupuesto } = useQuery(GET_ALL_RESULTADO_PRESUPUESTO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataResultadoPresupuesto) return;
    setResultadoPresupuestoCombo(adaptResultadoPresupuestoArray(dataResultadoPresupuesto?.allResultadoPresupuesto));
  }, [dataResultadoPresupuesto]);


  const { data: dataJustificacionMotivo } = useQuery(GET_ALL_JUSTIFICACION_MOTIVO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataJustificacionMotivo) return;
    setJustificacionMotivoCombo(adaptJustificacionMotivoArray(dataJustificacionMotivo?.allJustificacionMotivo));
  }, [dataJustificacionMotivo]);

  const { data: dataEstadoComercial } = useQuery(GET_ALL_ESTADO_COMERCIAL, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataEstadoComercial) return;
    setEstadoComercialCombo(adaptEstadoComercialArray(dataEstadoComercial?.allEstadoCondicionalComercial));
  }, [dataEstadoComercial]);

  const { data: dataEstadoMedico } = useQuery(GET_ALL_ESTADO_MEDICO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataEstadoMedico) return;
    setEstadoMedicoCombo(adaptEstadoMedicoArray(dataEstadoMedico?.allEstadoCondicionalMedico));
  }, [dataEstadoMedico]);

  const { data: dataMedioEnvio } = useQuery(GET_ALL_MEDIO_ENVIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataMedioEnvio) return;
    setMedioEnvioCombo(adaptMedioEnvioArray(dataMedioEnvio?.allMedioEnvioPresupuesto));
  }, [dataMedioEnvio]);

  const { data: dataFormatoPresupuesto } = useQuery(GET_ALL_FORMATO_PRESUPUESTO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataFormatoPresupuesto) return;
    const formatos = adaptFormatoPresupuestoArray(dataFormatoPresupuesto?.allFormatoPresupuesto);
    //TODO borrar este auto asignamiento cuando se acepten otros formatos aparte de PDF
    handleChange('formato', formatos?.find((x) => x?.displayName?.includes('PDF'))?.id);
    setFormatoCombo(formatos);
  }, [dataFormatoPresupuesto]);

  useEffect(() => {
    if (!gestionPresupuestos?.fechaAlta || gestionPresupuestos?.fechaAlta === '') {
      const fechaAltaAux = moment().format('yyyy-MM-DD');
      handleChange('fechaAlta', fechaAltaAux);
    }
  }, []);

  const handleSolicitarJustificacionClick = () => {
    if (!parametrosJustifiacion?.diasCondiContrato) {
      toast.error('El contrato no posee cantidad de dias condicionales');
    } else if (!requisitoCliente?.diasMaxFactCliente) {
      toast.error('El cliente no contiene cantidad maxima de dias a facturar');
    } else {
      solicitarJustificacion({
        variables: {
          input: {
            idEvaluacion: idEvaluacion,
            diasCondicional: parametrosJustifiacion?.diasCondiContrato,
            diasMaxFacturacionCliente: requisitoCliente?.diasMaxFactCliente,
            contratosCO: parametrosJustifiacion?.contratosCO
          }
        }
      }).then((response) => {
        getJustificacion({ variables: { idEvaluacion: idEvaluacion } });
      }).catch((error) => {
        console.log('Error al solicitar justificación:', error);
      });
    }
  };

  const handleClickPresentar = async () => {
    try {
      setImprimirPresupuestoLoading(true);

      if (!fullFormData?.condicionesContrato?.fechaDesde || !fullFormData?.condicionesContrato?.fechaHasta)
        throw 'El contrato debe tener fecha desde y hasta antes de presentar un presupuesto';
      if (!fullFormData?.condicionesContrato?.precioDiario)
        throw 'El contrato debe tener un precio diario válido';
      if (!gestionPresupuestos?.tipoPresupuesto)
        throw 'Debe elegir un Tipo de Presupuesto';
      if (!gestionPresupuestos?.idMedioEnvio)
        throw 'Debe elegir un Medio de envío';
      if (!gestionPresupuestos?.formato)
        throw 'Debe elegir un formato de archivo';

      const gestionPresupuestosAux = {
        ...gestionPresupuestos,
        fechaEnvioPresupuesto: gestionPresupuestos.fechaEnvioPresupuesto || moment().format('yyyy-MM-DD')
      };

      await handleSubmit(gestionPresupuestosAux);
      setGestionPresupuestos(gestionPresupuestosAux);

      const imprimirPresupuestoData = await imprimirPresupuesto();
      const response = imprimirPresupuestoData?.data?.imprimirPresupuesto;

      if (!!response.error) throw response.error;

      const presupuesto = response?.valorEsperado;

      if (!presupuesto)
        throw 'No se pudo imprimir el archivo, intentelo nuevamente más tarde.';

      const isPresupuestoCP = presupuesto.idTipoPresupuesto === idTipoPresupuestoCP;

      const typeIOMAId = tipoPresupuestoCombo?.find((x) => x.displayName.includes('IOMA'))?.id;
      const isIOMA = typeIOMAId === gestionPresupuestos?.tipoPresupuesto;

      const typeConFechaId = tipoPresupuestoCombo?.find((x) => x.displayName.includes('Con Fecha'))?.id;
      const isConFecha = typeConFechaId === gestionPresupuestos?.tipoPresupuesto;

      const Template = isPresupuestoCP ? TemplatePresupuestoCP : TemplatePresupuestoIOMA;

      const presupuestoHTML = document.createElement('div');
      const root = createRoot(presupuestoHTML);
      flushSync(() => {
        root.render(<Template presupuesto={presupuesto} isIOMA={isIOMA} isConFecha={isConFecha} />);
      });

      if (gestionPresupuestos?.formato === formatoCombo?.find((x) => x?.displayName?.includes('PDF'))?.id) {

        const pdf = new jsPDF({
          unit: 'pt',
          format: 'a4'
        });

        pdf.html(presupuestoHTML.innerHTML, {
          callback: function (doc) {
            const pdfBlob = doc.output('blob');
            fileDownload(pdfBlob, `Contrato-${presupuesto.idEvaluacion}.pdf`);
          },
          x: 10,
          y: 10
        });

      } else {
        toast.error('Formato no disponible momentaneamente.');
      }


    } catch (error) {
      toast.error(
        typeof error === 'string' ? error : JSON.stringify(error)
      );
    } finally {
      setImprimirPresupuestoLoading(false);
    }
  };

  const disableResultadoPresupuesto = () => {
    return fullFormData?.condicionesContrato?.estadoPrecio == ESTADO_PRECIO_PENDIENTE ||
      disableResPresupuestoNumeric() ||
      disableResPresupuestoDigital() ||
      disableResPresupuestoBoth();

  };

  const disableResPresupuestoNumeric = () => {
    return isClientAuthNumeric && !isClientAuthDigital && !!resultadoPresupuestoPrecargadoInicialmente;
  };

  const disableResPresupuestoDigital = () => {
    return isClientAuthDigital && !isClientAuthNumeric && !!resultadoPresupuestoPrecargadoInicialmente;
  };

  const disableResPresupuestoBoth = () => {
    return isClientAuthDigital && isClientAuthNumeric && !!resultadoPresupuestoPrecargadoInicialmente;
  };

  const validatedinputsRows = useMemo(() => {
    return structuredClone(inputsRows).map((group) => ({
      ...group,
      rows: group.rows.map((row) => ({
        ...row,
        hidden: row.name === 'adjuntoParticulares' && !fullFormData?.datosPrincipales?.financiadorParticular,
        inputs: row.inputs.map((input) => {
          switch (input.name) {
            case 'presupuestoAutorizado':
              input.disabled = gestionPresupuestos.idResultadoPresupuesto === 1;
              break;
            case 'idMedioEnvio':
              input.options = medioEnvioCombo;
              break;
            case 'formato':
              input.options = formatoCombo.filter((x) => !x?.displayName?.includes('WORD'));
              break;
            case 'tipoPresupuesto':
              input.options = tipoPresupuestoCombo;
              break;
            case 'solicitarJustificacion':
              input.disabled = !!gestionPresupuestos?.idJustificacion;
              input.onClick = () => handleSolicitarJustificacionClick();
              break;
            case 'fechaAlta':
              input.disabled = true;
              break;
            case 'idResultadoPresupuesto':
              let mappedCombo = puedeAprobar ?
                resultadoPresupuestoCombo :
                resultadoPresupuestoCombo.map((x) => ({ ...x, disabled: x.displayName === 'Aprobado' }));

              if (!esPlanConComplejidad || origen == 'PP' || fullFormData?.evaluacionAsistencial?.estadoMedico !== ESTADO_MEDICO_APROBADO)
                mappedCombo = mappedCombo.filter((x) => x.displayName !== 'Condicional');

              if (esPlanConComplejidad && noCumpleDiasCondicional && !gestionPresupuestos?.presupuestoAutorizado?.titulo && !gestionPresupuestos?.idJustificacion ||
                !!gestionPresupuestos?.idJustificacion && (
                  estadoComercialCombo.find((x) => x.displayName === 'Pendiente').id === gestionPresupuestos?.idEstadoComercial ||
                  estadoMedicoCombo.find((x) => x.displayName === 'Pendiente').id === gestionPresupuestos?.idEstadoMedico ||
                  estadoComercialCombo.find((x) => x.displayName === 'Rechazado').id === gestionPresupuestos?.idEstadoComercial ||
                  estadoMedicoCombo.find((x) => x.displayName === 'Rechazado').id === gestionPresupuestos?.idEstadoMedico)) {
                mappedCombo = mappedCombo.filter((x) => x.displayName === 'Rechazado');
              }

              input.options = [{ id: null, displayName: 'Vacio' }, ...mappedCombo];

              input.disabled = disableResultadoPresupuesto();

              if (origen === 'PR' && gestionPresupuestos.idResultadoPresupuesto === resultadoCondicionalId) {
                input.disabled = false;
                // input.options = resultadoPresupuestoCombo.filter((x) => x.displayName === 'Rechazado' || x.displayName === 'Condicional');
              }

              if (verifyRecjectEvalLoading) {
                input.disabled = true;
                input.endAdornment =
                  <InputAdornment position="end">
                    <CircularProgress size={20} color="inherit" />
                  </InputAdornment>;

              }
              break;
            case 'justificacionComercial':
              input.options = justificacionMotivoCombo;
              break;
            case 'justificacionMedico':
              input.options = justificacionMotivoCombo;
              break;
            case 'transferenciaParticulares':
              input.disabled = fullFormData?.gestionCrediticia?.idEstadoCrediticio == ESTADO_CREDITICIA_SATISFACTORIO;
              break;
            case 'idEstadoComercial':
              input.options = estadoComercialCombo;
              break;
            case 'idEstadoMedico':
              input.options = estadoMedicoCombo;
              break;
            case 'presentar':
              input.onClick = handleClickPresentar;
              input.isLoading = imprimirPresupuestoLoading;
              input.disabled = !!gestionPresupuestos?.idJustificacion && (estadoComercialCombo.find((x) => x.displayName === 'Aprobado').id !== gestionPresupuestos?.idEstadoComercial ||
                estadoMedicoCombo.find((x) => x.displayName === 'Aprobado').id !== gestionPresupuestos?.idEstadoMedico) ||
                fullFormData?.condicionesContrato?.estadoPrecio == ESTADO_PRECIO_PENDIENTE;
              break;
            case 'numeroSeguimiento':
              input.hidden = !isClientAuthNumeric;
              break;
            default:
              break;
          }
          if (!contratoEditable) {
            input.disabled = true;
          }
          return input;
        })
      }))
    }));
  }, [
    stepData,
    gestionPresupuestos,
    medioEnvioCombo,
    resultadoPresupuestoCombo,
    formatoCombo,
    estadoMedicoCombo,
    estadoComercialCombo,
    justificacionMotivoCombo,
    parametrosJustifiacion,
    esPlanConComplejidad,
    noCumpleDiasCondicional,
    origen,
    puedeAprobar,
    contratoEditable,
    requisitoCliente,
    imprimirPresupuestoLoading,
    fullFormData?.datosPrincipales?.financiadorParticular,
    fullFormData?.condicionesContrato?.estadoPrecio,
    fullFormData?.evaluacionAsistencial?.estadoMedico,
    fullFormData?.gestionCrediticia?.idEstadoCrediticio,
    verifyRecjectEvalLoading,
    isClientAuthNumeric]
  );

  const [deleteDocumento] = useMutation(DELETE_DOCUMENTO_CONTRATO);

  const handleSubmit = async (gestionPresParam) => {
    setPageLoading(true);
    const gestionPresupuestosToAdapt = gestionPresParam || gestionPresupuestos;

    if (!gestionPresParam && gestionPresupuestosToAdapt?.idResultadoPresupuesto !== preIdResultadoPresupuesto) {
      gestionPresupuestosToAdapt.fechaResultadoPresupuesto = moment().format('yyyy-MM-DD');
    }

    const inputGestionPresupuestos = adaptGestionPresupuestos(
      gestionPresupuestosToAdapt,
      idEvaluacion
    );

    try {
      await updateGestionPresupuesto({
        variables: { input: inputGestionPresupuestos }
      });
      if (cambioNumeroSeguimiento) setCambioNumeroSeguimiento(false);
      getJustificacion({ variables: { idEvaluacion: idEvaluacion } });

      // si la fecha de envío es nula y se completó la fecha de resultado --> se asigna esta última a la fecha de envío
      if (!gestionPresupuestos.fechaEnvioPresupuesto && !!gestionPresupuestos.fechaResultadoPresupuesto) {
        setGestionPresupuestos((prevDatos) => ({
          ...prevDatos,
          fechaEnvioPresupuesto: gestionPresupuestos.fechaResultadoPresupuesto
        }));
      }
    } catch (error) {
      if (gestionPresParam) {
        throw 'Ocurrió un error al presentar el presupuesto.';
      } else {
        toast.error('Error al guardar gestión de presupuestos');
      }
    } finally {
      setPageLoading(false);
    }
  };

  const handleDelete = async (name) => {
    const idArchivo = name === 'transferenciaParticulares' ? gestionPresupuestos.idTransferenciaParticulares : gestionPresupuestos.idPresupuestoAutorizado;
    try {
      const response = await deleteDocumento({ variables: { idDocumento: idArchivo } });
      if (response?.data?.deleteDocumentoContrato) {
        getArchivosPresupuesto({ variables: { idEvaluacion: idEvaluacion } });
        return toast.success('¡Documento eliminado con éxito!');
      }

      throw 'Se produjo un error al intentar eliminar el documento';
    } catch (error) {
      toast.error(typeof error === 'string' ? error : 'Se produjo un error al intentar eliminar el documento');
    }
  };

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [gestionPresupuestos, setDataSubmissionCallback, validatedinputsRows]);

  if (pageLoading) {
    return (
      <div className='tab-loading-section-contrato'>
        <CircularProgress />
      </div>);

  }

  return <div>
    <Grid
      container
      columns={100}
      columnSpacing={3}
      rowSpacing={3}>

      {validatedinputsRows.map((group, grIndex) => {
        if ((group.name === 'Justificación Comercial' || group.name === 'Justificación Medico') && !gestionPresupuestos.idJustificacion)
          return null;

        if ((!esPlanConComplejidad && origen != 'PP' || !noCumpleDiasCondicional && origen != 'PP' || origen == 'PP') && group.name === 'Condicional')
          return null;

        return <GroupedContainer key={grIndex} ungrouped={group.ungrouped} sectionTitle={group.name}>
          {group.rows.
            filter((row) => !row.hidden).
            map((row) =>
              row.inputs.
                filter((input) => !input.hidden).
                map((input, index) => {
                  return (
                    <Fragment
                      key={group.name + input.name + index}>

                      {
                        input.type === 'file' ? <Grid key={input.name + index} size={{ xs: 100, sm: 50, md: input.col, lg: input.col }}>
                          <h4>{input.title}</h4>
                          <RenderInputByTypeMobile
                            key={input.name + index}
                            handleChange={handleChangeImage}
                            handleDelete={(name) => handleDelete(name)}
                            input={input}
                            value={gestionPresupuestos[input.name]} />

                        </Grid> :

                          group.ungrouped ?
                            <RenderInputsRowByType
                              isRowWithTitle
                              key={input.name == 'idResultadoPresupuesto' ? gestionPresupuestos[input.name] + index : input.name + index}
                              input={input}
                              value={gestionPresupuestos[input.name]}
                              handleChange={handleChange} /> :


                            <RenderInputsRowByType
                              key={input.name + index}
                              input={input}
                              value={gestionPresupuestos[input.name]}
                              handleChange={handleChange} />

                      }
                    </Fragment>);

                })
            )}
        </GroupedContainer>;
      })}
    </Grid>
  </div>;
};

const inputsRows = [
  {
    name: 'Condicional',
    rows: [
      {
        inputs: [
          {
            displayName: 'Fecha de Solicitud',
            name: 'fechaAlta',
            type: 'date',
            disabled: true,
            col: 20
          },
          {
            displayName: 'Solicitar Justificación',
            name: 'solicitarJustificacion',
            type: 'button',
            col: 25
          },
          {
            displayName: 'item',
            name: 'item',
            required: true,
            type: 'item',
            col: 55
          }]

      }]

  },
  {
    name: 'Justificación Comercial',
    rows: [
      {
        inputs: [
          {
            displayName: 'Estado',
            name: 'idEstadoComercial',
            type: 'select',
            disabled: true,
            col: 28
          },
          {
            displayName: 'Justificación',
            name: 'justificacionComercial',
            type: 'select',
            disabled: true,
            col: 28
          },
          {
            displayName: 'Usuario',
            name: 'usuarioJustificacionComercial',
            disabled: true,
            type: 'string',
            col: 28
          },
          {
            displayName: 'Fecha',
            name: 'fechaJustificacionComercial',
            disabled: true,
            type: 'date',
            col: 16
          }]

      },
      {
        inputs: [
          {
            displayName: 'Observación',
            name: 'observacionComercial',
            disabled: true,
            type: 'long_string',
            col: 100
          }]

      }]

  },
  {
    name: 'Justificación Medico',
    rows: [
      {
        inputs: [
          {
            displayName: 'Estado',
            name: 'idEstadoMedico',
            type: 'select',
            disabled: true,
            col: 28
          },
          {
            displayName: 'Justificación',
            name: 'justificacionMedico',
            type: 'select',
            disabled: true,
            col: 28
          },
          {
            displayName: 'Usuario',
            name: 'usuarioJustificacionMedico',
            type: 'string',
            disabled: true,
            col: 28
          },
          {
            displayName: 'Fecha',
            name: 'fechaJustificacionMedico',
            type: 'date',
            disabled: true,
            col: 16
          }]

      },
      {
        inputs: [
          {
            displayName: 'Observación',
            name: 'observacionMedico',
            disabled: true,
            type: 'long_string',
            col: 100
          }]

      }]

  },
  {
    ungrouped: true,
    rows: [
      {
        inputs: [
          {
            displayName: 'F. envío presupuesto',
            name: 'fechaEnvioPresupuesto',
            type: 'date',
            disabled: true,
            col: 21
          },
          {
            displayName: 'Medio de envío',
            name: 'idMedioEnvio',
            type: 'select',
            col: 17
          },
          {
            displayName: 'Formato',
            name: 'formato',
            type: 'select',
            col: 10
          },
          {
            displayName: 'Tipo de presupuesto',
            name: 'tipoPresupuesto',
            type: 'select',
            col: 15
          },
          {
            displayName: 'Presentar',
            name: 'presentar',
            type: 'button',
            col: 12
          }]

      },
      {
        inputs: [
          {
            displayName: 'Observación',
            name: 'observacion',
            type: 'long_string',
            col: 100
          }]

      },
      {
        name: 'adjuntoParticulares',
        inputs: [
          {
            title: 'Transferencia de particulares',
            displayName: 'Adjuntar comprobante',
            name: 'transferenciaParticulares',
            required: true,
            type: 'file',
            isDesktop: true,
            col: 35
          },
          {
            displayName: 'item',
            name: 'item',
            required: true,
            type: 'item',
            col: 65
          }]

      },
      {
        inputs: [
          {
            title: 'Autorización de servicio',
            displayName: 'Adjuntar Autorización',
            name: 'presupuestoAutorizado',
            required: true,
            type: 'file',
            isDesktop: true,
            col: 35
          },
          {
            displayName: 'Resultado presupuesto',
            name: 'idResultadoPresupuesto',
            type: 'select',
            col: 15
          },
          {
            displayName: 'Fecha Resultado',
            name: 'fechaResultadoPresupuesto',
            type: 'date',
            disabled: true,
            col: 16
          },
          {
            displayName: 'Nro. Aprobación Presupuesto',
            name: 'numeroSeguimiento',
            type: 'string',
            col: 20
          }]

      }]

  }];